<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
      >
        <v-tab>
          Cronômetro em exibição
          <span class="tab-count" :class="{ 'tab-count--hidden': !(filteredCronometros && filteredCronometros.length > 0) }">
            {{ filteredCronometros && filteredCronometros.length > 0 ? filteredCronometros.length : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            aria-label="Buscar"
            class="colab-search"
          />
        </div>

        <div
          @dragover.prevent="handleDragOver"
          @dragenter.prevent="handleDragOver"
          @dragleave="handleDragLeave"
          @drop="handleDrop($event)"
          class="drop-zone"
          :class="{ 'drop-zone--active': isDragOver }"
        >
          <template>
            <div
              v-for="cronometro in filteredCronometros"
              :key="cronometro.id"
              class="card-item-wrapper"
              :class="{ 'drop-enter': lastDroppedId === cronometro.id }"
            >
              <CardCronometroEmExibicao
                :item="cronometro"
                :get-cronometros-producao="getCronometrosProducao"
                :get-cronometro-em-exibicao="getCronometroEmExibicao"
                :page-aprovada="aprovadas_current_page"
              />
            </div>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardCronometroEmExibicao from "../Cards/Cronometros/CardCronometroEmExibicao.vue";
import { dropTargetMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dropTargetMixin],
  components: { CardCronometroEmExibicao },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      media_type: null,
      midia_url_aprovadas: null,
      loading: false,
      filtro_texto: "",
    };
  },
  props: {
    cronometroEmExibicao: Array,
    aprovadas_current_page: Number,
    cod_producao: Number,
    cod_pasta: Number,
  },
  beforeMount() {
    this.filtro_texto =
      localStorage.getItem("@socialcam/filtro_texto_cronometro_exibicao") || "";
  },
  computed: {
    ...mapGetters({
      tarjaParams: "tarja_cronometro/getTarjaParams",
      configTarja: "tarja_cronometro/getConfigTarja",
    }),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    // Filter the em-exibição list client-side; there is no server-side
    // moderated list to refetch for cronômetros em exibição.
    filteredCronometros() {
      const list = this.cronometroEmExibicao || [];
      const query = (this.filtro_texto || "").trim().toLowerCase();
      if (!query) return list;
      return list.filter((cronometro) =>
        `${cronometro.dsc_titulo || ""} ${cronometro.dsc_descricao || ""}`
          .toLowerCase()
          .includes(query)
      );
    },
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  created() {
    this.getConfigTarja({ cod_producao: this.cod_producao });
  },
  methods: {
    ...mapActions({
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
      getCronometroEmExibicao: "cronometros/getCronometroEmExibicao",
      getConfigTarja: "tarja_cronometro/getConfigTarjaCronometro",
    }),
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    onChange(value) {
      localStorage.setItem("@socialcam/filtro_texto_cronometro_exibicao", value);
    },
    async onDropAction(item, selectedProducao) {
      const cod_producao = selectedProducao.cod_producao;
      const id = item.id;

      // Optimistic: drop it from the received list right away so the move feels instant.
      this.$store.commit("cronometros/removeCronometroProducao", id);

      try {
        await apiClient.patch(`/cronometro/setCronometroExibir/${id}/${cod_producao}`);
        await this.getCronometroEmExibicao({ cod_producao });

        // Only refetch if removing it emptied the current page while items remain
        // elsewhere — otherwise the list stays put with no jump.
        const list = this.$store.state.cronometros.cronometrosProducao;
        if (list && list.items && list.items.length === 0 && list.totalItems > 0) {
          await this.refetchRecebidos(cod_producao);
        }
      } catch (error) {
        console.error(error);
        await this.refetchRecebidos(cod_producao);
      }
    },
    refetchRecebidos(cod_producao) {
      return this.getCronometrosProducao({
        cod_producao,
        flg_favorita: this.$store.state.cronometros.flg_favorita,
        page: 1,
        size: 5,
        filtro_texto: this.$store.state.cronometros.filtroCronometros,
        cod_pasta: this.cod_pasta,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
